<template>
  <nav class="menu-stacked show">
    <div class="menu-items">
      <a
        v-for="section in sections"
        :key="section.id"
        :href="`#${section.anchorId}`"
        @click.prevent="handleClick(section.anchorId)"
        class="nav-button"
      >
        {{ section.nav_title }}
      </a>
    </div>
  </nav>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { composables } from '@/composables'

const router = useRouter()
const showMenu = composables().showMenu

defineProps({
  sections: {
    type: Array,
    default: () => []
  }
})

const handleClick = (anchorId) => {
  // Close menu
  showMenu.value = 0

  // Navigate with router to trigger scrollBehavior
  router.push({ hash: `#${anchorId}` })
}
</script>

<style scoped>
.menu-stacked {
  width: 100%;
  flex: 1;
}

.menu-items {
  height: 100%;
  padding: 3rem 2rem 7rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
}

.nav-button {
  font-family: var(--font-serif);
  display: block;
  color: var(--mahogany);
  text-decoration: none;
  text-transform: none;
  font-size: var(--text-2xl);
  line-height: var(--leading-tight);
  transition: color 0.2s ease-in-out;
  text-align: left;
  font-weight: var(--font-regular);
  letter-spacing: var(--tracking-normal);
}

.nav-button:hover {
  color: var(--dark);
}
</style>
